export default class slickSliders {
  constructor() {
    this.initSliders();
  }

  initSliders() {
    // Home slider
    const $mainSlider = $('.home__main .main-slider');
    const $mainSliderNav = $('.home__main .slider__navigation');

    if ($mainSlider.length) {
      $mainSlider.slick({
        arrows: false,
        dots: false,
        rows: 0,
        infinite: true,
        swipe: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      });

      $mainSliderNav.on('click', '.nav-element', (e) => {
        e.preventDefault();
        const $element = $(e.target).closest('.nav-element');
        const $listElement = $element.closest('li');
        const slideNumber = $element.attr('data-slide');

        $('.home__main .slider__navigation li').removeClass('active');
        (!$listElement.hasClass('active')) ? $listElement.addClass('active') : true;

        $mainSlider.slick('slickGoTo', slideNumber - 1);
      });
    }

    // Events slider
    const $eventsSlider = $('.home__events .events-slider');
    if ($eventsSlider.length) {
      $eventsSlider.slick({
        arrows: true,
        nextArrow: '.home__events .slick-next',
        prevArrow: '.home__events .slick-prev',
        dots: false,
        rows: 0,
        infinite: true,
        swipe: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 741,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 441,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    // News slider
    const $newsSlider = $('.home__news .news-slider');
    if ($newsSlider.length) {
      $newsSlider.slick({
        arrows: true,
        nextArrow: '.home__news .slick-next',
        prevArrow: '.home__news .slick-prev',
        dots: false,
        rows: 0,
        infinite: true,
        swipe: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 741,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 441,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    // Projects slider
    const $projectsHomeSlider = $('.home__projects .projects-slider');
    if ($projectsHomeSlider.length) {
      $projectsHomeSlider.slick({
        arrows: true,
        nextArrow: '.home__projects .slick-next',
        prevArrow: '.home__projects .slick-prev',
        dots: false,
        rows: 0,
        infinite: false,
        swipe: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              dots: true,
            },
          },
          {
            breakpoint: 641,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 381,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    // Projects slider
    const $projectsSlider = $('.projects__main__sliders .projects-slider__slides');
    if ($projectsSlider.length) {
      $projectsSlider.slick({
        arrows: true,
        nextArrow: '.projects-slider .slick-next',
        prevArrow: '.projects-slider .slick-prev',
        dots: false,
        rows: 0,
        infinite: false,
        swipe: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              dots: true,
            },
          },
          {
            breakpoint: 641,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 381,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    // Editions slider
    const $editionsSlider = $('.projects__main__sliders .editions-slider__single');
    if ($editionsSlider.length) {
      $editionsSlider.slick({
        arrows: true,
        dots: false,
        rows: 0,
        infinite: false,
        swipe: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              dots: true,
            },
          },
          {
            breakpoint: 381,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/slickSliders.js